import request from "@/utils/request";

//获取榜单列表
export function getEnterpriseRankList() {
	return request({
		url: "/financing/getEnterpriseRankList",
		method: "get",
	});
}

// 获取优秀企业列表
export function getExcellentEnterprisesList(data) {
	console.log(data)
	return request({
		url: "/financing/excellentEnterprisesList",
		method: "post",
		data,
	});
}



